import { ActionsRegion } from '@app/Types/Actions';
import { TypeLoading } from '@services/ServiceWidget/TypePromise';

export interface ServiceByShop {
  title: string;
  url: string;
}

export enum Type {
  Phone = 'phone',
}

export enum RegionCode {
  Empty = '',
  Reg1 = 'reg_1',
}

export interface Territory {
  id: number;
  shopId: number;
  territory: string;
  active: string;
}

export interface YandexRating {
  Rating: string;
  Reviews: string;
  Estimate: string;
}

export interface Rating {
  rating: string;
  ratingCount: number;
}

export enum Name {
  'Количество постов' = 'Количество постов',
  SeasonSave = 'Season save',
  TradeIn = 'Trade-In',
  Автомойка = 'Автомойка',
  Автосервис = 'Автосервис',
  Магазин = 'Магазин',
  Шиномонтаж = 'Шиномонтаж',
}

export interface Service {
  title: string;
  name: string;
  id: number;
  checked: boolean;
  visible: boolean;
}

export enum Code {
  Avtomoyka = 'avtomoyka',
  Avtoservice = 'avtoservice',
  Cx = 'cx',
  Shinomontazh = 'shinomontazh',
  NoWidgetShinomontazh = 'noWidgetShinomontazh',
  Shop = 'shop',
  Tradein = 'tradein',
  Post = 'post',
}

export interface OneLevelService {
  name: Name;
  code: Code;
  post?: number;
}

export enum Comment {
  CommentСервис = 'сервис',
  Empty = '',
  Автосервис = 'автосервис',
  Магазин = 'магазин',
  Сервис = 'Сервис',
  ТорговыйЗал = 'торговый зал',
  Хранение = 'хранение',
  ШиномонтажИАвтосервис = 'Шиномонтаж и автосервис',
}

export interface InfoMessage {
  text: string;
}

export interface Phone {
  id: number;
  shopId: number;
  phone: string;
  ext: null | string;
  type: Type;
  comment: Comment | null;
  sort: number;
}

export interface TypeMap {
  x: number;
  y: number;
  zoom?: number;
}

export interface Map {
  id: number;
  shopId: number;
  xCoord: number;
  yCoord: number;
  zoom: number;
  comment: string;
  yandexMapId: string;
  yandexMapUrl: string;
  googleMapUrl: string;
  gisMapUrl: string;
  iconUrl: null;
  eyeColor: null;
  color: null | string;
  outerStrokeColor: null;
  yandexRating: string;
  yandexRatingCount: string;
  yandexRatingReviews: string;
  proirity_slider: string;
}

export interface Image {
  id: number;
  shopId: number;
  fileImg: string;
  sort: number | null;
}

export interface ShopsForActions {
  id: number;
  title: string;
  regionCode: RegionCode;
  region: string;
  name: string;
  code: string;
  address: string;
  detailText: null | string;
  about: null | string;
  email: string;
  emailOrder: null | string;
  phone: string;
  phoneSms: null | string;
  phoneMount: null | string;
  phoneMess: string | null;
  timework: string;
  proezd: null | string;
  department: string;
  delivery: string;
  pickup: string;
  territory: string;
  isMichelin: string;
  public: string;
  partners: number;
  externalId: null | string;
  iblockId: number | null;
  sort: number;
  active: string;
  posts: number;
  newAbout: string;
  proiritySlider: string;
  shopAbout: string;
  phones: Phone[];
  territories: Territory[];
  maps: Map[];
  images: Image[];
}

export interface Shop {
  id: number;
  name: string;
  address: string;
  code: string;
  timework: string;
  phone: string;
  partnerType?: number;
  map: Map;
  yandexMap: string;
  yandexRating: YandexRating;
  infoMessage: InfoMessage | null;
  rating: Rating;
  image: string;
  oneLevelServices: OneLevelService[];
  inStock?: boolean;
}

export interface PartnerShops {
  name: string;
  partner: string;
  idPartner: number;
}

export interface NewPhone {
  phone: string;
  ext: string;
  comment: string;
}

export interface SocialNetWork {
  title: string;
  img: string;
  url: string;
}

export interface Option {
  id: number;
  name: string;
  code: string;
}

export interface InfoDirector {
  person_image: string;
  person_name: string;
  person_email: string;
  person_phone: string;
  position_name: string;
}

export interface ShopInfo {
  id: number;
  url: string;
  name: string;
  title: string;
  address: string;
  timeWork: string;
  partners: number;
  aboutShop: string;
  email: string;
  phones: string[];
  newPhones: NewPhone[];
  socialNetWork: SocialNetWork[];
  actionsRegion: ActionsRegion[];
  autoServices: any[];
  options: Option[];
  oneLevelServices: OneLevelService[];
  galleryShop: string[];
  infoDirector: InfoDirector;
  map: Map;
  yandexMap: string;
  yandexRating: YandexRating;
  rating: Rating;
  loading: TypeLoading;
}
